import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Conversation, ShortMessageStatus} from '../../../../models/inbox';
import {CommonConstant} from '../../../app.constants';

@Component({
  selector: 'conversation-list',
  templateUrl: './conversation-list.component.html',
  styleUrls: ['./conversation-list.component.scss']
})
export class ConservationListComponent {
  public scrollDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE;
  public scrollUpDistance = CommonConstant.DEFAULT_INFINITE_SCROLL_DISTANCE_UP;
  public throttle = CommonConstant.DEFAULT_INFINITE_SCROLL_THROTTLE;
  @Input()
  public conversations: Conversation[];
  @Input()
  public editable = false;

  @Output()
  public removeConversation = new EventEmitter<Conversation>();

  @Output()
  public selectConversation = new EventEmitter<Conversation>();

  @Output()
  public fetchNextConversations = new EventEmitter<Conversation>();

  constructor() { }

  public onRemoveConversation(conversation: Conversation) {
    this.removeConversation.emit(conversation);
  }

  public onSelectConversation(conversation: Conversation) {
    this.selectConversation.emit(conversation);
  }
  onScrollDown() {
    this.fetchNextConversations.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer-inbox/conversation-list/conversation-list.component.ts